import React, { Component } from 'react';
import AccessForm from '../components/AccessForm';
import TermsForm from '../components/TermsForm';
import ContributionChoiceForm from '../containers/ContributionChoiceForm'
import AddressContainer from '../containers/AddressContainer'
import { connect } from 'react-redux'
import { loadSession } from '../actions'
import ReactGA from 'react-ga'

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  componentDidMount() {
    ReactGA.pageview(window.location.pathname)
  }

  render() {
    const { is_whitelisted, token, email, address, accept_terms, is_registered, show_address } = this.props
    const showAccessForm = !show_address && !is_whitelisted && !accept_terms && !address
    const showTermsForm = !show_address && is_whitelisted && token && !accept_terms && !address
    // const showContributionChoiceForm = !show_address && !!email && !!token && !!address && accept_terms
    const showAddressContainer = address && show_address && accept_terms && !!email && !!token
    return (
      <div className="wrapper">
        <div className="container centered">
          <div className="header">
            {
              !is_registered && is_whitelisted && token && !accept_terms
              ? <div className="HomeButton"><a href="/">Back to email confirmation</a></div>
              : <div></div>
            }
            <img src="logo.jpg" alt="Indorse" />

            {/*{ showContributionChoiceForm ? <h3>Your Contribution Method</h3> : '' }*/}
            { showAccessForm ? <h3>Token Sale</h3> : '' }

          </div>
          { showAccessForm  ? <AccessForm /> : '' }
          { showTermsForm ? <TermsForm /> : '' }
          {/*{ showContributionChoiceForm ? <ContributionChoiceForm /> : ''}*/}
          { showAddressContainer ? <AddressContainer /> : ''}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { registrations } = state
  const { is_whitelisted, token, address, accept_terms, email, request, is_registered, show_address } = registrations
  return { is_whitelisted, token, address, accept_terms, email, request, is_registered, show_address }
}

export default connect(
  mapStateToProps,
  { loadSession }
)(App)


// WEBPACK FOOTER //
// ./src/containers/App.js